import { AxiosResponse } from 'axios';
import type { AxiosInstance } from 'axios';
import { inject } from '@aesop-fables/containr';
import { ApiServices } from '../ApiServices';

export class GroupSelectionApi {
  constructor(@inject(ApiServices.Axios) private axios: AxiosInstance) {}

  select(groupId: number): Promise<AxiosResponse<string>> {
    return this.axios.post(`group-selection/select/${groupId}`);
  }

  unselect(): Promise<AxiosResponse<string>> {
    return this.axios.post('group-selection/unselect');
  }
}
